/**
 * SmeadIT Website Monitor — Firebase initialisation (KO Holistic Health website)
 *
 * Initialises a SEPARATE named Firebase app ('smeadit-widget') that connects to
 * SmeadIT's Firebase project. This is entirely independent of the KO website's
 * own Firebase — nothing in the existing config is changed or affected.
 *
 * Connected to SmeadIT WebsiteMonitor — site: KO Holistic Health (kohealth)
 */

import { initializeApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth, signInAnonymously } from 'firebase/auth';

export const SMEADIT_SITE_ID = 'a8tH03Fc6CM6hvtpV9jK';

// Client identifier for the public website — must match the SmeadIT dashboard entry
export const SMEADIT_CLIENT_ID = 'kohealth';

const SMEADIT_CONFIG = {
  apiKey: 'AIzaSyClLLb9pwG8zM804j_yWIfLaJoyUPmwBBQ',
  authDomain: 'smeadit-1fab6.firebaseapp.com',
  projectId: 'smeadit-1fab6',
  storageBucket: 'smeadit-1fab6.appspot.com',
  messagingSenderId: '431137308549',
  appId: '1:431137308549:web:592de471c2c3e82c98ceec',
};

const APP_NAME = 'smeadit-widget';

// Guard against double-init on React hot-reload
const smeaditApp = getApps().find(a => a.name === APP_NAME)
  ?? initializeApp(SMEADIT_CONFIG, APP_NAME);

export const smeaditDb = getFirestore(smeaditApp);
export const smeaditStorage = getStorage(smeaditApp);
export const smeaditAuth = getAuth(smeaditApp);

// Authenticate anonymously so Firestore security rules pass
signInAnonymously(smeaditAuth).catch(err =>
  console.warn('SmeadIT: anonymous auth failed', err)
);
